import { NavLink } from "react-router-dom";
import { panelMenu } from "../routes";
import { useAuth } from "../../context/AuthContext";

export const getInitials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

export default function Sidebar() {
  const { user, hasRole, logout } = useAuth();

  const menu = panelMenu
    .map((g) => ({ ...g, items: g.items.filter((i) => hasRole(i.roles)) }))
    .filter((g) => g.items.length);

  const handleLogout = () => {
    logout();
    window.location.replace("/login");
  };

  return (
    <div className="sidebar">
      <div className="brand">
        <div className="mark">
          <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
            <path
              d="M4 17V7l8-4 8 4v10l-8 4-8-4z"
              stroke="#fff"
              strokeWidth="1.8"
              strokeLinejoin="round"
            />
            <path
              d="M4 7l8 4 8-4M12 11v10"
              stroke="#fff"
              strokeWidth="1.8"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="bt">
          CorpBills<span>Corporate portal</span>
        </div>
      </div>

      <div className="nav-scroll">
        {menu.map((g) => (
          <div className="nav-group" key={g.group}>
            <div className="ng-label">{g.group}</div>
            {g.items.map(({ path, label, icon: Icon, badge }) => (
              <NavLink
                key={path}
                to={path}
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <Icon />
                {label}
                {badge ? <span className="badge">{badge}</span> : null}
              </NavLink>
            ))}
          </div>
        ))}
      </div>

      <div className="sidebar-foot">
        <div className="role-box">
          <div className="avatar-sm">{getInitials(user?.name)}</div>
          <div className="rb-txt">
            <span
              style={{
                display: "block",
                fontSize: 9,
                color: "var(--text-faint)",
              }}
            >
              Signed in as
            </span>
            <strong>{user?.roleName}</strong>
            <span>{user?.name}</span>
          </div>
          <button
            type="button"
            className="btn"
            onClick={handleLogout}
            style={{
              marginLeft: "auto",
              color: "#fff",
              background: `linear-gradient(
    150deg,
    var(--violet-light),
    var(--violet) 55%,
    var(--violet-dark)
  )`,
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
